/**
 * 业务错误类
 * 用于标记业务层面的错误（如"登录超时"、"余额不足"等），
 * 这类错误不应该被上报到 RUM 监控系统
 */
export class BusinessError extends Error {}
